import React, { useEffect, useState } from "react";
import auth from "../../services/authServices";
import http from "../../services/httpServices";
import UpcomingLiveSessions from "../../pages/UpcomingLiveSessions";
import Heading from "../../components/NewUi/heading/Heading";
import Button from "../../components/ui/Button";
import OffsetButton from "../../components/ui/Buttons/OffsetButton";
import { ReactComponent as QuranIcon } from "../../assets/telawah-assets/quranIconBtn.svg";
import { useLanguage } from "../../context/LanguageContext";

const HomeSectionLiveSessionSection = () => {
    const [requestedSessions, setRequestedSessions] = useState({
        upcoming_live_sessions: [],
        previous_live_sessions: [],
    });
    const { language } = useLanguage();
    const content = {
        headingTitle: {
            en: "Live",
            ar: "الجلسات",
        },
        headingSubtitle: {
            en: "Sessions",
            ar: "المباشره",
        },
        bookingPrompt: {
            en: "Book your session now at a time that suits you and on the topic of your choice!",
            ar: "احجز دلوقتي معاد مع الجلسات المباشره في الميعاد اللي يناسبك و في الموضوع اللي انت عاوزه !",
        },
        bookNow: {
            en: "Go to Booking Now!",
            ar: "اذهب للحجز الآن !",
        },
    };
    const getAttendantSessions = async () => {
        const token = auth.getToken();
        const config = auth.getAuthConfig(token);
        try {
            const { data: response } = await http.get(
                `/api/live_sessions/requested_sessions`,
                config
            );
            setRequestedSessions(response);
        } catch ({ response }) {
            // console.log(error);
        }
    };
    useEffect(() => {
        getAttendantSessions();
    }, []);
    return (
        <div className={`${language}`}>
            {requestedSessions.upcoming_live_sessions &&
            requestedSessions.upcoming_live_sessions.length > 0 ? (
                <>
                    <UpcomingLiveSessions
                        isHomeSection
                        UpcomingLiveSessions={requestedSessions.upcoming_live_sessions}
                    />
                    <div className="flex-center-both flex-col py-10 space-y-5">
                        <p className="text-gray-700 text-center w-full md:w-1/2 dark:text-gray-200 smooth font-h3 font-w-bold">
                            {content.bookingPrompt[language]}
                        </p>
                        <div className=" pt-10 md:pb-0 w-fit  ">
                            <OffsetButton
                                color="earthYellow"
                                className="flex-center-both text-lg gap-4"
                                to="/session_reservation"
                            >
                                <QuranIcon className="mb-1 w-7 h-full " />
                                {content.bookNow[language]}
                            </OffsetButton>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="flex-center-both flex-col space-y-10">
                        <Heading
                            title={content.headingTitle[language]}
                            subtitle={content.headingSubtitle[language]}
                        />
                        <p className="text-gray-700 text-center w-full md:w-1/2 dark:text-gray-200 smooth font-h3 font-w-bold">
                            {content.bookingPrompt[language]}
                        </p>
                        <div className=" pt-10 md:pb-0 w-fit  ">
                            <OffsetButton
                                color="earthYellow"
                                className="flex-center-both text-lg gap-4"
                                to="/session_reservation"
                            >
                                <QuranIcon className="mb-1 w-7 h-full " />
                                {content.bookNow[language]}
                            </OffsetButton>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default HomeSectionLiveSessionSection;
